import { jsx as s } from "react/jsx-runtime";
import { forwardRef as N, useRef as D, useState as R, useEffect as x, useCallback as o } from "react";
import { InputLeftElement as F } from "@chakra-ui/react";
import { useDebouncedCallback as K } from "use-debounce";
import { MagnifyingGlassIcon as L } from "../../icons/componentIcons.mjs";
import { Input as O } from "../Input/Input.mjs";
import j from "./ClearFieldButton.mjs";
import { combineClasses as z } from "../../../utils/combineClasses.mjs";
import "react-nanny";
const G = N((d, m) => {
  const {
    onSearch: c,
    className: v,
    hasButton: t = !1,
    onChange: r,
    onClear: a,
    placeholder: C = "Search...",
    size: S = "md",
    value: l,
    wait: w = 300,
    ...b
  } = d, g = D(null), n = m || g, [y, i] = R(!1), h = K(c, w);
  x(() => {
    l && u(l);
  }, []);
  const B = z(
    t ? "search-input-with-button" : "search-input-no-button",
    v
  ), u = o((e) => {
    i(e !== "");
  }, []), f = o(() => {
    var p;
    const e = n;
    e.current && c((p = e.current) == null ? void 0 : p.value);
  }, [n, c]), E = o(
    (e) => {
      r == null || r(e), u(e.target.value), !t && h(e.target.value);
    },
    [t, r, u]
  ), k = o(() => {
    const e = n;
    a == null || a(), e != null && e.current && (e.current.value = "", e.current.focus()), i(!1), !t && h("");
  }, [t, n, a]), I = o(
    (e) => {
      e.key === "Enter" && f();
    },
    [f, n]
  );
  return /* @__PURE__ */ s(
    O,
    {
      ref: n,
      type: "search",
      className: B,
      placeholder: C,
      size: S,
      variant: "outline",
      inputLeftElementOverride: t ? void 0 : /* @__PURE__ */ s(F, { pointerEvents: "none", className: "search-input-left-element-icon", children: /* @__PURE__ */ s(L, { variant: "light" }) }),
      inputRightElementOverride: y ? /* @__PURE__ */ s(j, { isSearchBtnDisplayed: t, onClick: k }) : void 0,
      showSearchButton: !!t,
      onChange: E,
      onSearchClick: t ? f : void 0,
      onKeyDown: t ? I : void 0,
      value: l,
      ...b
    }
  );
});
G.displayName = "SearchInput";
export {
  G as SearchInput
};
